export default __webpack_public_path__ + "f5af436ae9babcb4c5e98b1ee5fabf86.svg";